import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { Input } from "stories/forms";
import { useAppContext } from "contexts/AppContext"

const OptionAssetTypeInput = ({label, name="asset_type", onChange, value, allOption = true, disabled}) => {
  const { t } = useTranslation();
  const { enums } = useAppContext()
  
  const getInputOptions = useCallback(() => {
    const inputOptions = enums?.options?.option?.asset_type;
    return inputOptions && inputOptions.map(obj => {
      return (
        <option key={obj.key} value={obj.key}>{obj.value}</option>
      )
    })
  }, [enums])
  
  return (
    <Input label={label ? label : t("asset_type_input_label")} type="select" name={name} onChange={onChange} value={value} disabled={disabled}>
      { allOption && (
        <option value="">{t("Kaikki")}</option>
      )}
      {getInputOptions()}
    </Input>
  )
  
  
}


export default OptionAssetTypeInput;